import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import moment from 'moment';
import { debounce, isEmpty } from 'lodash';
import { bob, k2aCore } from '../../../data/tabs';

import HealthMonitorTable from '../HealthMonitorTable/HealthMonitorTable';
import EquipmentTable from './EquipmentTable';
import EnergyTable from './EnergyTable';
import SitesTable from './SitesTable';
import SystemsTable from './SystemsTable';
import BobActionMenu from '../../../components/BobActionMenu';
import BobModal from '../../../components/BobModal';
import FilterChip from '../../../components/FilterChip';
import BobFilterComponent from '../../../components/BobFilterComponent';
import NavModal from '../Modals/NavModal';
import ContactsTable from '../Contacts/ContactsTable';
import ContactsTableActionMenu from '../Contacts/ContactsTableActionMenu';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import { getActiveTabName } from '../Navigation/NavigationHelper';
import SearchInput from '../../Global/SearchInput';
import TotalsPanel from '../../../components/TotalsPanel';
import TabViewSelector from '../../../components/TabViewSelector';
import CreateSubscriptionModal from '../Modals/CreateSubscriptionModal';
import ExportDataModal from '../Modals/ExportDataModal';

import queryString from 'query-string';

import { withRouter } from 'react-router-dom';

import {dashboardContent} from '../../../localization/en-us/dashboardContent';
import {getTimeZoneAbbr} from '../../../helpers/timezones';

import {
    renderChip,
    renderFilter,
    removeFilter
} from '../../../helpers/tableContainerHelper';

import * as ContactActions from '../../../actions/contactActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './TableContainer.module.css';
import { setPageTitle } from '../../../helpers/auth';

const TABNAMES = {
    'Site':           dashboardContent.sites,
    'Equipment':      dashboardContent.equipment,
    'System':         dashboardContent.systems,
    'Health Monitor': 'Health Monitor'
};

const TableContainer = ({
    activeNavCompany,
    activeNavClient,
    activeTab,
    bulkDeleteContact,
    buildingTypes,
    cardScores,
    clientContacts,
    clientEquipmentMeta,
    clientFilters,
    clientSitesMeta,
    clientSystemsMeta,
    companyApplications,
    dashboardIsCurrentTimeStamp,
    equipmentFilters,
    equipmentTypes,
    exportTableData,
    fetchClientContacts,
    history,
    healthMonitorFilters,
    issueTypes,
    isShowExportModal,
    setActiveTab,
    setClientFilters,
    setEquipmentFilters,
    setHealthMonitorFilters,
    setSiteFilters,
    setSystemFilters,
    setWorkBookMode,
    siteFilters,
    systemFilters,
    systemTypes,
    workbookModeEnabled,
    ...props
}) => {
    const [createSiteModalOpen, handleToggleCreateSiteModal] = useState(false);
    const [createEquipmentModalOpen, handleToggleCreateEquipmentModal] = useState(false);
    const [deleteSiteModalOpen, handleToggleDeleteSiteModal] = useState(false);
    const [deleteSystemModalOpen, handleToggleDeleteSystemModal] = useState(false);
    const [deleteEquipmentModalOpen, handleToggleDeleteEquipmentModal] = useState(false);
    const [subscribeToAlertsSiteModalOpen, handleToggleSubscribeToSiteAlertsModal] = useState(false);
    const [subscribeToAlertsEqquipmentModalOpen, handleToggleSubscribeToEquipmentAlertsModal] = useState(false);
    const [subscribeToAlertsSystemsModalOpen, handleToggleSubscribeToSystemsAlertsModal] = useState(false);
    const [subscribeToRuleAlertsModalOpen, setSubscribeToRuleAlertsModalOpen] = useState(false);
    const [subscribeToCampusModalOpen, setSubscribeToCampusModalOpen] = useState(false);

    const [siteTableProps, setSiteTableProps] = useState({});
    const [equipmentTableProps, setEquipmentTableProps] = useState({});
    const [systemTableProps, setSystemTableProps] = useState({});
    const [contactTableSelectState, setContactTableSelectState] = useState({});
    const [searchTerm, setSearchTerm] = useState('');

    const [navModalOpen, setNavModalOpen] = useState(false);

    const [refreshTab, setRefreshTab] = useState('');
    const [exportColumns, setExportColumns] = useState([]);
    const _export = React.useRef(null);
    const _contactExport = React.useRef(null);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [isexportNodeHealthChecks, setIsexportNodeHealthChecks] = useState(false);

    useEffect(() => {
        if (activeNavClient.name) {
            setPageTitle(activeNavClient.name, activeTab);
        }
    }, [activeNavClient.name]);

    useEffect(() => {
        const { pathname } = history.location;
        const queryValues = queryString.parse(history.location.search);
        
        let key = queryValues.appId;
            
        if ( queryValues.parentId ) {
            key = queryValues.parentId;
        }

        if ( queryValues.childId ) {
            key = queryValues.childId;
        }

        let activetab = getActiveTabName(key);
        if (!isEmpty(activeNavClient)) {
            setPageTitle(activeNavClient.name, activetab);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
        setSearchTerm('');
        setTimeout(() => {
            setActiveTab(activetab);
        }, 100);
    }, [history.location.search]);

    const getActiveTabTableProps = () => {
        let tableProps = {};

        if (activeTab === 'Site') {
            tableProps = siteTableProps;
        } else if (activeTab === 'Equipment') {
            tableProps = equipmentTableProps;
        } else if (activeTab === 'System') {
            tableProps = systemTableProps;
        }

        return tableProps;
    };

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleHealthMonitorExport = event => {
        const statusColumn = exportColumns.findIndex(c => c.field === 'status');
        const priorityColumn = exportColumns.findIndex(c => c.field === 'priority');
        const issueTypeColumn = exportColumns.findIndex(c => c.field === 'issueTypes');
        const equipmentSystemColumn = exportColumns.findIndex(c => c.field === 'equipmentSystem');
        const routeColumn = exportColumns.findIndex(c => c.field === 'snapshotRoute');
        const faultTimestampColumn = exportColumns.findIndex(c => c.field === 'faulttimestamp');
        const options = _export.current.workbookOptions();
        const rows = options.sheets[0].rows;
        rows.forEach(row => {
            if (row.type === 'data') {
                const statusCell = row.cells[statusColumn];
                const priorityCell = row.cells[priorityColumn];
                const issueTypeCell = row.cells[issueTypeColumn];
                const routeCell = row.cells[routeColumn];
                const equipmentSystemCell = row.cells[equipmentSystemColumn];
                const faultTimestampCell = row.cells[faultTimestampColumn];
                equipmentSystemCell.value = routeCell.value.substring(routeCell.value.lastIndexOf('/') + 1);
                statusCell.value = statusCell.value.toString().toLowerCase() === 'true' ? 'Fault' : 'OK';
                priorityCell.value = priorityCell.value === 0 ? 'Low' : priorityCell.value === 1 ? 'Medium' : 'High';
                issueTypeCell.value = issueTypeCell.value.join(', ');
                faultTimestampCell.value = faultTimestampCell.value ? moment(faultTimestampCell.value).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(faultTimestampCell.value), moment.tz.guess()) : null;
            }
        });
        _export.current.save(options);
    };

    const healthMonitorRawDataExport = event => {
        setIsexportNodeHealthChecks(true);
    };
    
    const renderTotalsData = activeTab => {
        switch (activeTab) {
            case 'Site':
                return clientSitesMeta;
            case 'Equipment':
                return clientEquipmentMeta;
            case 'System':
                return clientSystemsMeta;
            case 'Health Monitor':
                return cardScores;
            default:
                return;
        }
    };

    const renderSelectData = activeTab => {
        switch (activeTab) {
            case 'Site':
                return buildingTypes;
            case 'Equipment':
                return equipmentTypes;
            case 'System':
                return systemTypes;
            case 'Health Monitor':
                return issueTypes;
            default:
                return [];
        }
    };

    const renderLabel = activeTab => {
        // Both case 1 (equipment) and case 2 (system) use
        // equipment type to describe the entity.
        switch (activeTab) {
            case 'Site':
                return 'Building Types';
            case 'Equipment':
                return 'Equipment Types';
            case 'System':
                return 'System Types';
            case 'Health Monitor':
                return 'Issue Types';
            default:
                return '';
        }
    };

    const selectSetFilter = activeTab => {
        switch (activeTab) {
            case 'Site':
                return setSiteFilters;
            case 'Equipment':
                return setEquipmentFilters;
            case 'System':
                return setSystemFilters;
            case 'Health Monitor':
                return setHealthMonitorFilters;
            default:
                return;
        }
    };

    const handleSetFilter = activeTab => {
        return selectSetFilter(activeTab);
    };

    const activeFilters = {
        'Site':           siteFilters,
        'Equipment':      equipmentFilters,
        'System':         systemFilters,
        'Health Monitor': healthMonitorFilters
    };

    const renderActiveFilters = activeTab => {
        let filters = activeFilters[activeTab] || {};

        return renderFilter(filters);
    };

    const renderChips = activeTab => {
        let filters = activeFilters[activeTab] || {};

        if (isEmpty(filters)) return [];

        return renderChip(filters);
    };

    const handleRemoveFilter = (activeTab, item) => {
        const setFilters = selectSetFilter(activeTab);
        let filters = activeFilters[activeTab];

        removeFilter(setFilters, filters, item);
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);

        const { pathname } = history.location;
        const { key } = tabView;

        queryValues.childId = key;
        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);
    };

    const handleCreateSite = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=e979b520-3695-422d-a914-ba55c51fb316&company=${activeNavCompany.id}&entityType=site&client=${activeNavClient.id}&parentId=3ee59a8f-d13a-475b-b424-ee55eef98a65`,
                state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=f6ba2344-ba47-42c5-a98b-978365ca3936&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280` }
            })
            :
            handleToggleCreateSiteModal(true);
    };

    const handleCreateEquipment = () => {
        process.env.k2aCoreEnabled ?
            history.push({
                pathname: `/v2/dashboard/core/entities/manage`,
                search:   `appId=${k2aCore.key}&childId=7e2354df-ebb5-4c68-a1a4-57cc84dd61eb&company=${activeNavCompany.id}&entityType=equipment&client=${activeNavClient.id}&parentId=3ee59a8f-d13a-475b-b424-ee55eef98a65`,
                state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=8404408d-ad6f-472e-b9dd-34383b392178&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280`}

            })
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleCreateSystem = () => {
        process.env.k2aCoreEnabled ?
            setNavModalOpen(true)
            :
            handleToggleCreateEquipmentModal(true);
    };

    const handleGo = () => {
        history.push({
            pathname: `/v2/dashboard/core/entities/manage`,
            search:   `appId=${k2aCore.key}&childId=d0f113f5-32e1-4e2c-bf4d-386edb7f9bc4&client=d4ab2cfd-b3c5-40c7-ac6c-08e977bce69a&company=${activeNavCompany.id}&entityType=system&parentId=33ba6af0-1e7a-4fcf-b75b-f355a01a962b&site=42d3a03d-41ba-4b3c-b155-069b7d20ad3a`,
            state:    { 'returnUrl': `/v2/dashboard/client?appId=${bob.key}&childId=e3b10bc7-eec5-45e5-8ad2-e94c8f50ca95&client=${activeNavClient.id}&company=${activeNavCompany.id}&parentId=a73c8c70-35aa-48b7-a797-4c607ae25280` }
        });
    };

    const handleCreateContact = () => {
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);
        history.push(`/v2/dashboard/contacts?${queryValuesString}`);
    };

    const handleDeleteContacts = async () => {
        if (isEmpty(contactTableSelectState)) return;

        let filteredContactState = { ...contactTableSelectState };

        for (var key in filteredContactState) {
            if (filteredContactState[key] === false) {
                delete filteredContactState[key];
            }
        }

        const ids = Object.keys(filteredContactState);

        if (ids) {
            await bulkDeleteContact(ids);
            await fetchClientContacts(activeNavClient.id);
            setContactTableSelectState({});
        }
    };

    const refreshGrid = () => {
        setRefreshTab(activeTab);
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const handleContactExport = () => {
        const options = _contactExport.current.workbookOptions();
        const rows = options.sheets[0].rows;

        rows.forEach((row, index) => {
            if (row.type === 'data') {
                const nameCell = row.cells[0];
                const primaryCell = row.cells[3];
                const smsCell = row.cells[4];
                const numbers = _contactExport.current.props.data[index - 1].userAssignmentPhones;

                const name = _contactExport.current.props.data[index - 1].userName;
                const primary = numbers.find(item => item.isPrimary === true);
                const sms = numbers.find(item => item.isSMS === true);

                nameCell.value = name.FirstName + ' ' + name.LastName;
                primaryCell.value = primary ? primary.phoneNumber.number : null;
                smsCell.value = sms ? sms.phoneNumber.number : null;
            }
        });

        if (_contactExport.current !== null) {
            _contactExport.current.save(options);
        }
    };

    return (
        <div className={classes.TableContainer}>
            {
                activeTab === 'Site' || activeTab === 'Equipment' || activeTab === 'System' || activeTab === 'Health Monitor' || activeTab === 'Contact' ?
                    <div className={classes.TableContainerHead}>
                        <div className={classes.SelectContainer}>
                            <TabViewSelector
                                overviewPage={'client'}
                                activeTab={activeTab}
                                handleChangeView={handleChangetabView}
                            />
                        </div>
                        {
                            activeTab === 'Health Monitor' ?
                                <div className={classes.SearchContainer}>
                                    <SearchInput
                                        key={new Date()}
                                        className={classes.SearchInput}
                                        search={debounce(handleSearch, 700)}
                                        placeholder={`Search by ${activeTab === 'Health Monitor' ? 'Rule' : activeTab} Name`}
                                        value={searchTerm}
                                    />
                                </div>
                                : null
                        }
                        <div className={classes.TotalsContainer}>
                            {
                                activeTab === 'Site' || activeTab === 'System' || activeTab === 'Equipment' || activeTab === 'Contact' ?
                                    <div className={activeTab === 'Contact' ? classes.ContactWorkbookMode : classes.WorkbookModeContainer}>
                                        <BobWorkbookModeButton
                                            handleWorkbookMode={handleWorkbookMode}
                                            workbookMode={workbookModeEnabled}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                (activeTab !== 'Equipment' && activeTab !== 'System') && dashboardIsCurrentTimeStamp ?
                                    <TotalsPanel
                                        data={renderTotalsData(activeTab)}
                                        entityType={`${activeTab}s`}
                                    />
                                    : null
                            }
                        </div>
                    </div>
                    : null
            }
            {
                process.env.dashboardFilteringEnabled && activeTab !== 'Energy' ?
                    <div className={classes.FilterContainer}>
                        {renderChips(activeTab).map((item, index) => (
                            <FilterChip
                                key={index}
                                item={item}
                                removeFilter={() => handleRemoveFilter(activeTab, item)}
                            />
                        ))}
                        { activeTab === 'Health Monitor' ?
                            <BobFilterComponent
                                data={renderSelectData(activeTab)}
                                label={renderLabel(activeTab)}
                                filterType={TABNAMES[activeTab]}
                                activeFilters={renderActiveFilters(activeTab)}
                                setFilters={handleSetFilter(activeTab)}
                                showStatusFilter={ activeTab === 'Health Monitor' ? true : false}
                            />
                            : null}
                    </div>
                    :
                    null
            }
            {
                activeTab === 'Energy' || activeTab === 'Service' || activeTab === 'Schedule'? 
                    null :
                    <div
                        className={classes.RefreshContainer}
                        aria-hidden="true"
                        role="button"
                        tabIndex={0}
                        onClick={refreshGrid}
                    >
                        <span className="material-icons-outlined">refresh</span>
                    </div>
            }
            {
                process.env.dashboardEnergyEnabled && activeTab === 'Energy' ?
                    null
                    :
                    <div className={classes.ActionButtonContainer}>
                        {
                            activeTab === 'Contact' ?
                                <ContactsTableActionMenu
                                    handleDeleteContacts={handleDeleteContacts}
                                    handleCreateContact={handleCreateContact}
                                    handleContactExport={handleContactExport}
                                />
                                :
                                <BobActionMenu
                                    isExport={activeTab !== 'Health Monitor'}
                                    activeTab={`Client${TABNAMES[activeTab]}`}
                                    handleExport={handleExport}
                                    handleHealthMonitorExport={handleHealthMonitorExport}
                                    handleCreateEquipment={() => handleCreateEquipment()}
                                    handleCreateSystem={() => handleCreateSystem(true)}
                                    handleCreateSite={() => handleCreateSite()}
                                    handleSubscribeToCampus={() => setSubscribeToCampusModalOpen(true)}
                                    isHealthMonitor={activeTab === 'Health Monitor'}
                                    healthMonitorRawDataExport={healthMonitorRawDataExport}
                                />
                        }
                    </div>
            }
            <div className={classes.GridContainer}>
                {
                    activeTab === 'Site' ?
                        <SitesTable
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            totalsData={renderTotalsData(activeTab)}
                            createSiteModalOpen={createSiteModalOpen}
                            deleteSiteModalOpen={deleteSiteModalOpen}
                            subscribeToAlertsSiteModalOpen={subscribeToAlertsSiteModalOpen}
                            handleToggleSubscribeToSiteAlertsModal={(value) => handleToggleSubscribeToSiteAlertsModal(value)}
                            handleToggleCreateSiteModal={(value) => handleToggleCreateSiteModal(value)}
                            handleToggleDeleteSiteModal={(value) => handleToggleDeleteSiteModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setSiteTableProps}
                            searchTerm={searchTerm}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'Equipment' ?
                        <EquipmentTable
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            totalsData={renderTotalsData(activeTab)}
                            createEquipmentModalOpen={createEquipmentModalOpen}
                            deleteEquipmentModalOpen={deleteEquipmentModalOpen}
                            subscribeToAlertsEqquipmentModalOpen={subscribeToAlertsEqquipmentModalOpen}
                            handleToggleSubscribeToEquipmentAlertsModal={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                            handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                            handleToggleDeleteEquipmentModal={(value) => handleToggleDeleteEquipmentModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setEquipmentTableProps}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'System' ?
                        <SystemsTable
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            totalsData={renderTotalsData(activeTab)}
                            isFromSystemTab={true}
                            createEquipmentModalOpen={createEquipmentModalOpen}
                            deleteSystemModalOpen={deleteSystemModalOpen}
                            subscribeToAlertsSystemsModalOpen={subscribeToAlertsSystemsModalOpen}
                            handleToggleSubscribeToSystemsAlertsModal={(value) => handleToggleSubscribeToSystemsAlertsModal(value)}
                            handleToggleCreateEquipmentModal={(value) => handleToggleCreateEquipmentModal(value)}
                            handleToggleDeleteSystemModal={(value) => handleToggleDeleteSystemModal(value)}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            setTableProps={setSystemTableProps}
                            searchTerm={searchTerm}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        : null
                }
                {
                    activeTab === 'Health Monitor' ?
                        <HealthMonitorTable
                            node={{type: 'client', id: activeNavClient.id}}
                            searchTerm={searchTerm}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                            healthMonitorFilters={healthMonitorFilters}
                            exportRef={_export}
                            setExportColumns={setExportColumns}
                            exportColumns={exportColumns}
                            setIsexportNodeHealthChecks={setIsexportNodeHealthChecks}
                            isexportNodeHealthChecks={isexportNodeHealthChecks}
                            subscribeToRuleAlertsModalOpen={subscribeToRuleAlertsModalOpen}
                            setSubscribeToRuleAlertsModalOpen={(value) => setSubscribeToRuleAlertsModalOpen(value)}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Contact' ?
                        <ContactsTable
                            _contactExport={_contactExport}
                            view="client"
                            refreshTab={refreshTab}
                            contactTableSelectState={contactTableSelectState}
                            setContactTableSelectState={setContactTableSelectState}
                            setRefreshTab={() => setRefreshTab('')}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                {
                    activeTab === 'Energy' ? 
                        <EnergyTable
                            activeTab={activeTab}
                            isActive={true}
                            refreshTab={refreshTab}
                            setRefreshTab={() => setRefreshTab('')}
                        /> 
                        : null
                }
            </div>
            { isShowExportModal ?
                <BobModal
                    title={''}
                    isOnlyContent={true}
                >
                    <h3>Preparing Export</h3>
                </BobModal> : ''
            }
            {
                navModalOpen ?
                    <NavModal
                        menu={'site'}
                        handleGo={handleGo}
                        setNavModalOpen={setNavModalOpen}
                    />
                    :
                    null
            }
            {
                subscribeToCampusModalOpen ?
                    <CreateSubscriptionModal
                        parent={{ ...activeNavClient, clientId: activeNavClient.id }}
                        parentLabel="Client"
                        type="campus"
                        handleToggleSubscribeToAlertsModal={setSubscribeToCampusModalOpen}
                    />
                    :
                    null
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={activeNavClient}
                        setExportModalOpen={setExportModalOpen} 
                        tabView={`Client${TABNAMES[activeTab]}`}
                        tableProps = { getActiveTabTableProps() }
                    /> : ''
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:            state.bob.activeNavCompany,
        activeNavClient:             state.bob.activeNavClient,
        buildingTypes:               state.architect.buildingTypes,
        cardScores:                  state.home.cardScores,
        clientContacts:              state.contact.clientContacts,
        clientEquipmentMeta:         state.dashboard.clientEquipmentMeta,
        clientSitesMeta:             state.dashboard.clientSitesMeta,
        clientSystemsMeta:           state.dashboard.clientSystemsMeta,
        companyApplications:         state.bob.companyApplications,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        equipmentFilters:            state.dashboard.equipmentFilters,
        equipmentTypes:              state.equipmentTypes.data,
        healthMonitorFilters:        state.dashboard.healthMonitorFilters,
        isShowExportModal:           state.dashboard.isShowExportModal,
        issueTypes:                  state.svcManagement.issueTypes,
        siteFilters:                 state.dashboard.siteFilters,
        systemFilters:               state.dashboard.systemFilters,
        systemTypes:                 state.systemTypes.data,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...ContactActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
